import { createGenericListItemReducer } from "common/genericListItemReducer";
import { createGenericReducer } from "common/genericReducer";
import reduceReducers from "reduce-reducers";
import {
  MERCHANDISE_CHANNELS_FAILED,
  MERCHANDISE_CHANNELS_RECEIVED,
  MERCHANDISE_CHANNELS_REQUESTED,
  MERCHANDISE_CHANNEL_DETAIL_RECEIVED,
  MERCHANDISE_CHANNEL_DETAIL_REQUESTED,
  MERCHANDISE_CHANNEL_DETAIL_REQUEST_FAILED
} from "./merchandiseActions";

export const merchandise = reduceReducers(
  createGenericReducer(MERCHANDISE_CHANNELS_REQUESTED, MERCHANDISE_CHANNELS_RECEIVED, MERCHANDISE_CHANNELS_FAILED),
  createGenericListItemReducer(
    MERCHANDISE_CHANNEL_DETAIL_REQUESTED,
    MERCHANDISE_CHANNEL_DETAIL_RECEIVED,
    MERCHANDISE_CHANNEL_DETAIL_REQUEST_FAILED
  )
);
